import { useEffect } from "react";

export default function CookiePolicy() {
  useEffect(() => {
    const script = document.createElement("script");
    script.id = "CookieDeclaration";
    script.src = "https://consent.cookiebot.com/d6a22caf-0799-46d1-b062-138b968cb678/cd.js";
    script.type = "text/javascript";
    script.async = true;

    const placeholder = document.getElementById("cookie-declaration-placeholder");
    if (placeholder) {
      placeholder.appendChild(script);
    }

    return () => {
      if (placeholder) placeholder.innerHTML = "";
    };
  }, []);

  return (
    <div className="privacy-page">
      <div className="privacy-wrapper">
        <div className="privacy-container">
          <h1>Política de Cookies</h1>
          <p>
            Esta página contém a declaração de cookies gerada automaticamente pelo
            Cookiebot. Ela lista todos os cookies utilizados no nosso site,
            incluindo sua finalidade, duração e provedor. Você pode alterar ou
            revogar seu consentimento a qualquer momento através do banner de
            cookies.
          </p>
  
          {/* Cookiebot injects the cookie table here */}
          <div id="cookie-declaration-placeholder"></div>
        </div>
      </div>
    </div>
  );
}  


